// @flow

import { useEffect, useRef } from 'react';

/*
 * Custom hook to get previous props and state
 * https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 */

const usePrevious = (value: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default usePrevious;
